// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ui-pie-donut-chart{align-items:center;display:flex;gap:16px}.ui-pie-donut-chart .chart-wrapper{flex:0 0 auto;line-height:0;width:-moz-fit-content;width:fit-content}.ui-pie-donut-chart .legend-container{align-content:center;-moz-column-gap:16px;column-gap:16px;display:flex;flex:1 1 auto;flex-direction:row;flex-wrap:wrap;max-width:300px;min-width:0;row-gap:4px}.ui-pie-donut-chart .legend-item{align-items:center;display:flex;flex:0 1 auto;gap:4px;max-width:calc(50% - 8px);min-width:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"a": "#5a80fb",
	"b": "#6b88fc",
	"c": "#7b91fc",
	"d": "#8899fd",
	"e": "#95a2fd",
	"f": "#a1abfe",
	"g": "#adb4fe",
	"h": "#b8bdfe",
	"i": "#c3c6ff",
	"j": "#cdcfff",
	"k": "#d8d9ff",
	"l": "#e2e2ff",
	"m": "#ececff",
	"n": "#f5f5ff",
	"o": "#fff"
};
module.exports = ___CSS_LOADER_EXPORT___;
